module.exports = __webpack_public_path__ + "img/img_sub_ser_consulting03.99f62164.svg";